import React, { useState, useEffect, useRef, useMemo } from "react";
import { Modal, Button, Carousel } from "antd";
import { useTranslation } from "react-i18next";
import logger from "@/utils/logger";
import Image1 from "@/assets/feature/1.png";
// import Image2 from '@/assets/feature/2.png';
// import Image3 from '@/assets/feature/3.png';
// import Image4 from '@/assets/feature/4.png';
// import Image5 from '@/assets/feature/5.png';
import NavGuide from "@/assets/images/joyspace/nav_guide.png";
import ShortcutGuide from "@/assets/images/joyspace/shortcut_guide.png";
import FileGuide from "@/assets/images/joyspace/file_guide.png";
import UploadGuide from "@/assets/images/joyspace/upload_guide.png";
import Mask from "@/assets/images/joyspace/mask.png";

import ImService from "@/server/ImService";
import { FocusSDK } from "@/utils";
import { getAppVersion } from "@/utils/getVersion";
import guideImg from "@/assets/images/joyspace/guide.png";
import "./index.less";
import ReactDOM from "react-dom";
import { useLocation } from "react-router-dom";
import { changeEgovUrl } from "@/utils/tools";

const log = logger.getLogger("NewVersionGuide");

function GuideComp(props: any) {
  const { onSkip } = props;
  const list = [Mask];
  const [current, setCurrent] = useState(0);
  const [height, setHeight] = useState(0);
  const carouselRef = useRef(0);
  const { t } = useTranslation("common");

  const navGuideRef = useRef<HTMLImageElement>(null);
  const shortcutGuideRef = useRef<HTMLImageElement>(null);
  const fileGuideRef = useRef<HTMLImageElement>(null);
  const uploadGuideRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const notifyHeight = document.getElementsByClassName("notify-area")[0];
    setHeight(notifyHeight?.clientHeight || 0);
  }, []);

  // let current = 0;
  const nextStep = () => {
    // current++;
    carouselRef.current = carouselRef.current + 1;

    setCurrent(carouselRef.current);
  };
  const getFooter = useMemo(() => {
    const isEnd = current === list.length - 1;
    return (
      <div className="footer-space">
        {!isEnd && (
          <Button size="middle" onClick={onSkip}>
            {t("newVersion.skip")}
          </Button>
        )}
        <Button size="middle" type="primary" onClick={() => (isEnd ? onSkip() : nextStep())}>
          {list.length === 1
            ? "我知道了"
            : isEnd
            ? t("newVersion.complete")
            : t("newVersion.nextStep")}
        </Button>
      </div>
    );
  }, [list.length, onSkip, t, current]);

  return (
    <>
      <img
        ref={navGuideRef}
        onLoad={() => {
          navGuideRef.current && (navGuideRef.current.style.display = "block");
        }}
        src={changeEgovUrl(NavGuide)}
        className="nav-guide-img"
      />
      <img
        ref={shortcutGuideRef}
        onLoad={() => {
          shortcutGuideRef.current && (shortcutGuideRef.current.style.display = "block");
        }}
        src={changeEgovUrl(ShortcutGuide)}
        className="shortcut-guide-img"
      />
      <img
        ref={fileGuideRef}
        onLoad={() => {
          fileGuideRef.current && (fileGuideRef.current.style.display = "block");
        }}
        src={changeEgovUrl(FileGuide)}
        className="file-guide-img"
      />
      <img
        ref={uploadGuideRef}
        onLoad={() => {
          uploadGuideRef.current && (uploadGuideRef.current.style.display = "block");
        }}
        style={{ top: `${height + 40}px` }}
        src={changeEgovUrl(UploadGuide)}
        className="upload-guide-img"
      />
      {getFooter}
    </>
  );
}

export default function NewVersionGuide(props: any) {
  const { pathname } = useLocation();
  const ele = document.createElement("div");
  ele.setAttribute("class", "joyspace-guide-space");
  const isWeb = FocusSDK.getDeviceInfo().platform === "web";
  const version = getAppVersion(FocusSDK);
  const checkNewVersion = async () => {
    // 网页端暂时不弹出引导页
    let isUp = false;
    if (isWeb) {
      const isShowJoyspaceGuide = localStorage.getItem("isShowJoyspaceGuide-" + version);
      if (isShowJoyspaceGuide) {
        return;
      }
      isUp = true;
    } else {
      const imService = ImService.getInstance();
      isUp = await imService?.isAppUpgraded(version, "joyspace");
    }
    if (isUp) {
      document.body.appendChild(ele);
      ReactDOM.render(<GuideComp {...{ ...props, onSkip }} />, ele);
    }
  };
  const onSkip = async () => {
    if (ele) {
      if (isWeb) {
        localStorage.setItem("isShowJoyspaceGuide-" + version, "true");
      } else {
        const imService = ImService.getInstance();
        await imService?.setAppVersion(version, "joyspace");
      }

      ReactDOM.unmountComponentAtNode(ele);
      ele.remove();
    }
  };

  useEffect(() => {
    checkNewVersion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
